import React from 'react';
import gsap from 'gsap';
export var useToggle = function useToggle(state, options) {
  var _a = React.useState(null),
      ref = _a[0],
      setRef = _a[1];

  var _b = React.useState(0),
      loaded = _b[0],
      setLoaded = _b[1];

  var tl = React.useRef(gsap.timeline({
    paused: true
  })).current;
  React.useLayoutEffect(function () {
    tl.reversed(state);

    if (options instanceof Array) {
      options.forEach(function (option) {
        tl.to(ref, option);
      });
    } else {
      tl.to(ref, options);
    }
  }, [tl, ref, options]);
  var animate = React.useCallback(function () {
    state ? tl.reverse() : tl.play();
  }, [tl, state]);
  React.useEffect(function () {
    if (loaded) {
      animate();
    }

    setLoaded(loaded + 1);
  }, [state]);
  return setRef;
};